import {lazy} from 'react';
import {ROUTES} from 'core/constants';
import {IRoute} from 'core/interfaces';

const MyProjectsScene = lazy(() => import('./MyProjectsScene/MyProjectsScene'));
const SystemScene = lazy(() => import('./SystemScene/SystemScene'));
const SamplesAndBlendsScene = lazy(() => import('./SamplesAndBlendsScene/SamplesAndBlendsScene'));
const TechProcessScene = lazy(() => import('./TechProcessScene/TechProcessScene'));

export const MAIN_ROUTES: IRoute[] = [
  {
    path: ROUTES.MyProjects,
    element: <MyProjectsScene />
  },
  {
    path: ROUTES.TechProcess,
    element: <TechProcessScene />
  },
  {
    path: ROUTES.SamplesAndBlends,
    element: <SamplesAndBlendsScene />
  },
  {
    path: ROUTES.System,
    element: <SystemScene />
  }
];
